import React from 'react';

import { SVGPropsType } from 'src/types';

function ExpandIn(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path d="M14 6L10 6L10 2" stroke={stroke} strokeLinejoin="round" />
            <path d="M9 13H13V9" stroke={stroke} strokeLinejoin="round" />
            <path d="M7 3H3V7" stroke={stroke} strokeLinejoin="round" />
            <path d="M2 10L6 10L6 14" stroke={stroke} strokeLinejoin="round" />
            <path d="M14 2L10 6" stroke={stroke} />
            <path d="M6 10L2 14" stroke={stroke} />
        </svg>
    );
}

export default ExpandIn;
